<template>
  <div class="background-color-white pb-3" id="keep-search">
    <RedeemInStoreDialog
      :product="product"
      :dialog="dialog"
      :close="closeDialog"
    />
    <v-row
      class="background-secondary-color fill-height mb-5"
      align="center"
      justify="center"
      ><v-col cols="1" class="pl-5">
        <v-icon @click="$router.go(-1)" color="white"
          >mdi-arrow-left</v-icon
        > </v-col
      ><v-col cols="11" class="pt-5 pl-0 text-center">
        <span class="color-white redeem-reward">Redeem reward</span><br />
        <span v-if="product.redemption_points_offer" class="my-balance"
          >My Balance:
        </span>
        <span v-if="product.redemption_points_offer" class="color-white points">
          {{ total_points_remaining }} points</span
        >
      </v-col></v-row
    >
    <SurgeonGeneralsWarning
      v-if="product.tobacco_warning"
      :text="product.tobacco_warning"
    />
    <AlcoholProductsRequireIdWarning v-if="product.is_alcohol" />
    <v-container>
      <v-row class="pt-1">
        <v-col cols="3" class="confetti-left"></v-col>
        <v-col
          cols="6"
          class="d-flex justify-center overflow-hidden position-relative"
        >
          <div class="align-center d-flex justify-center position-relative">
            <img
              v-if="product.image || product.paywithpoints"
              :alt="product.name"
              :src="product.image || require('@/assets/payWithPoints.svg')"
              style="height: 120px"
            />
            <NoImageAvailable
              v-else
              style="height: 120px"
              :departmentName="
                getProductDepartmentName(
                  product.parent_categories,
                  product.categories,
                )
              "
              :size="'sm'"
            />
          </div>
        </v-col>
        <v-col cols="3" class="confetti pr-0"></v-col>
        <v-col class="align-center d-flex justify-center">
          <span class="font-size-md font-weight-semibold">{{
            product.name
          }}</span>
        </v-col>
        <v-col cols="12" class="">
          <div class="px-12">
            <v-row>
              <v-col>
                <UnitPriceDisplay
                  :byweight="product.byweight"
                  :type="'generic'"
                  :unitPrice="product.cents"
                  :redeemable="
                    !!product.redemption_points_offer_id ||
                    product.is_redemption
                  "
                  :points="product.redemption_points_offer"
                />
              </v-col>
            </v-row>
            <span v-if="product.brand" class="color-suva-grey">
              <br />
              {{ product.brand }}
            </span>
            <UnitSizeDisplay
              :baseSize="product.base_size"
              :size="product.size"
              :uom="product.uom"
            />
          </div>

          <v-row class="mt-5 justify-center">
            <v-col
              v-if="!rewardsFormat && !product.paywithpoints"
              cols="5"
              class="d-flex justify-center"
            >
              <CartQuantityButton
                :cartProduct="product"
                :quantityType="'cartQty'"
                small
              />
            </v-col>

            <v-col cols="7" class="d-flex justify-center">
              <div class="text-center">
                <v-btn
                  rounded
                  :color="disableRedeemInStore ? 'grey' : 'secondary'"
                  dark
                  block
                  large
                  class="px-8"
                  @click="
                    disableRedeemInStore ? (dialog = false) : (dialog = true)
                  "
                  :outlined="disableRedeemInStore"
                  :class="{ 'disable-events': disableRedeemInStore }"
                >
                  <Icon
                    class="mt-1"
                    name="qr_scan"
                    :color="disableRedeemInStore ? 'grey' : 'white'"
                    :style="{
                      height: '25px',
                      width: '25px',
                      'vertical-align': 'inherit',
                    }"
                  ></Icon>
                  <span
                    class="font-size-sm font-weight-bold text-none text-center"
                    >Redeem in Store</span
                  >
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div
                class="color-suva-grey font-size-sm position-relative"
                :class="
                  product.is_tobacco || product.is_alcohol
                    ? 'visible'
                    : 'hidden'
                "
              >
                <AlcoholWarning v-if="product.is_alcohol" xs />
                <TobaccoWarning v-if="product.is_tobacco" xs />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { getProductDepartmentName } from "@/util.js";
import AlcoholProductsRequireIdWarning from "@/elements/AlcoholProductsRequireIdWarning.vue";
import AlcoholWarning from "@/components/Product/AlcoholWarning.vue";
import CartQuantityButton from "@/components/Product/CartQuantityButton.vue";
import NoImageAvailable from "@/components/Product/NoImageAvailable.vue";
import SurgeonGeneralsWarning from "@/components/UI/SurgeonGeneralsWarning.vue";
import TobaccoWarning from "@/components/Product/TobaccoWarning.vue";
import UnitPriceDisplay from "@/components/Product/UnitPriceDisplay.vue";
import UnitSizeDisplay from "@/components/Product/UnitSizeDisplay.vue";
import { mapGetters } from "vuex";
import Icon from "@/components/UI/Icon.vue";
import RedeemInStoreDialog from "../Dialogs/RedeemInStore.vue";

export default {
  name: "LoyaltyProductDetailsView",
  components: {
    AlcoholProductsRequireIdWarning,
    AlcoholWarning,
    CartQuantityButton,
    Icon,
    NoImageAvailable,
    RedeemInStoreDialog,
    SurgeonGeneralsWarning,
    TobaccoWarning,
    UnitPriceDisplay,
    UnitSizeDisplay,
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    getProductDepartmentName,
    closeDialog() {
      this.dialog = false;
    },
  },
  computed: {
    ...mapGetters("store", {
      total_points_remaining: "total_points_remaining",
      rewardsFormat: "rewardsFormat",
    }),
    disableRedeemInStore() {
      return this.total_points_remaining < this.product.redemption_points_offer;
    },
  },
  props: { product: Object },
};
</script>

<style scoped>
.favorite-button-position {
  position: absolute;
  top: 0;
  left: -50px;
}
.redeem-reward {
  font-size: 16px;
  font-weight: 600;
}
.my-balance {
  color: rgba(255, 255, 255, 0.6);
  font-family: Roboto;
  font-size: 16px;
}
.points {
  font-weight: 600;
}
.confetti-left {
  background-image: url("~@/assets/Confetti_Left.svg");
  background-repeat: round;
}
.confetti {
  background-image: url("~@/assets/Confetti.svg");
  background-repeat: round;
}
.disable-events {
  pointer-events: none;
}
</style>
